import React from 'react';
import { useHistory } from 'react-router';
import { track } from '@amplitude/analytics-browser';
import { Alert, Box, Button, Text } from '@nimbus-ds/components';
import { ROUTES } from 'App/Routes/constants';
import { useTranslationWithPrefix } from 'commons/utils';

interface BankAccountInactiveAlertProps {
  title: string;
}

const BankAccountInactiveAlert = ({
  title,
}: BankAccountInactiveAlertProps): JSX.Element => {
  const { t } = useTranslationWithPrefix('commons.bankAccountInactiveAlert');
  const history = useHistory();

  const handleUpdateClick = () => {
    track('pago-nube-editar-cbu');
    history.push(ROUTES.BANK_ACCOUNT_CONFIG);
  };

  return (
    <Alert appearance="danger" title={title}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap="4"
      >
        <Text>{t('description')}</Text>
        <Button appearance="neutral" onClick={handleUpdateClick}>
          {t('button')}
        </Button>
      </Box>
    </Alert>
  );
};

export default BankAccountInactiveAlert;
